import { render, staticRenderFns } from "./pelletlager.vue?vue&type=template&id=457f3f23"
import script from "./pelletlager.vue?vue&type=script&lang=ts"
export * from "./pelletlager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports